import { Button, Tooltip, alpha, useTheme } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ShareLinkCommentResolveButton({ resolved, onClick, dataCy }) {
    const theme = useTheme()
    const isResolved = !!resolved

    return (
        <Tooltip arrow title={getResolveTitle()}>
            <Button
                size="small"
                color="success"
                variant={getResolveButtonVariant()}
                onClick={onClick}
                data-cy={dataCy}
                aria-label={getResolveTitle()}
                aria-pressed={isResolved}
                startIcon={<Iconify icon={getResolveIcon()} width={14} height={14} />}
                sx={getResolveButtonSx()}
            >
                {getResolveLabel()}
            </Button>
        </Tooltip>
    )

    function getResolveTitle() {
        return isResolved ? "Reopen comment" : "Mark resolved"
    }

    function getResolveLabel() {
        return isResolved ? "Resolved" : "Resolve"
    }

    function getResolveButtonVariant() {
        return isResolved ? "contained" : "text"
    }

    function getResolveIcon() {
        return isResolved ? "mdi:check-circle" : "mdi:check-circle-outline"
    }

    function getResolveButtonSx() {
        return {
            minHeight: 24,
            px: 0.75,
            py: 0.25,
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1.4,
            textTransform: "none",
            border: 0,
            bgcolor: isResolved ? getResolvedBackgroundColor() : alpha(theme.palette.success.main, 0.08),
            color: isResolved ? theme.palette.common.white : theme.palette.success.dark,
            "&:hover": {
                border: 0,
                bgcolor: isResolved ? getResolvedHoverBackgroundColor() : alpha(theme.palette.success.main, 0.14),
            },
            "& .MuiButton-startIcon": {
                ml: 0,
                mr: 0.5,
            },
        }
    }

    function getResolvedBackgroundColor() {
        return theme.palette.success.darker ?? theme.palette.success.dark
    }

    function getResolvedHoverBackgroundColor() {
        return theme.palette.success.dark ?? getResolvedBackgroundColor()
    }
}
